<header class="page-header">
  <div class="page-header__copy">
    <h1>{{ title() }}</h1>
    @if (description()) {
      <p>{{ description() }}</p>
    }
  </div>
  <div class="page-header__actions">
    <ng-content />
  </div>
</header>
